import { Component, OnInit, Injectable } from "@angular/core";
import { ToastrService } from "ngx-toastr";
import { ReportingService } from "./core/services/reporting.service";
import { ActivatedRoute } from "@angular/router";
import { MAT_DATE_FORMATS, DateAdapter } from "@angular/material/core";
import {
  APP_DATE_FORMATS,
  AppDateAdapter,
} from "./core/services/custom-calender.service";
import { AppConfig } from "./configs/app.config";

@Injectable({
  providedIn: "root",
})
@Component({
  selector: "app-root",
  templateUrl: "./app.component.html",
  styleUrls: ["./app.component.scss"],
  providers: [
    { provide: DateAdapter, useClass: AppDateAdapter },
    { provide: MAT_DATE_FORMATS, useValue: APP_DATE_FORMATS },
  ],
})
export class AppComponent implements OnInit {
  constructor(
    public toastr: ToastrService,
    public reportService: ReportingService,
    public route: ActivatedRoute,
  ) {}

  ngOnInit() {
    if (AppConfig.WHITE_LABEL_MODE) {
      this.setThemeColor();
      this.setWelcomeImg();
    }
  }

  setThemeColor() {
    document.documentElement.style.setProperty(
      "--brand-color3",
      AppConfig.BRAND_TERTIARY_COLOUR
    );
    document.documentElement.style.setProperty(
      "--brand-color2",
      AppConfig.BRAND_SECONDARY_COLOUR
    );
    document.documentElement.style.setProperty(
      "--brand-color",
      AppConfig.BRAND_PRIMARY_COLOUR
    );
    document.documentElement.style.setProperty(
      "--chip-color",
      AppConfig.CHIP_COLOR
    );
    document.documentElement.style.setProperty(
      "--chip-bg-color",
      AppConfig.CHIP_BG_COLOR
    );
    document.documentElement.style.setProperty(
      "--warning-bg-color",
      AppConfig.MSG_BG_COLOR
    );
  }

  setWelcomeImg() {
    document.documentElement.style.setProperty(
      "--welcome-img",
      `url(${AppConfig.WELCOME_IMG})`
    );
  }
}
